import { render, staticRenderFns } from "./NewsItemBlock.vue?vue&type=template&id=4e941059&"
import script from "./NewsItemBlock.vue?vue&type=script&lang=ts&"
export * from "./NewsItemBlock.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports